import { tableDefaults } from "./defaultConfig.js";

export const serviceTableConfig = () => ({
    ...tableDefaults,
    columns: [
        { title: "Name", field: "name", headerFilter: "input" },
        { title: "Beschreibung", field: "description", headerFilter: "input" },
        { title: "URL", field: "url", headerFilter: "input" },
    ],
});
